// import React from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import { getItems, deleteItem } from '../../../api/item';
// import { Link } from 'react-router-dom';
// import { toast } from 'react-toastify';

// const ItemList = () => {
//   const queryClient = useQueryClient();
//   const { data: items, error, isLoading } = useQuery('items', getItems);

//   const deleteMutation = useMutation(deleteItem, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('items');
//       toast.success('Item deleted successfully');
//     },
//     onError: () => {
//       toast.error('Failed to delete item');
//     }
//   });

//   if (isLoading) return <div>Loading...</div>;
//   if (error) return <div>Error: {error.message}</div>;

//   return (
//     <div>
//       <h1>Items</h1>
//       <Link to="/dashboard/items/new">Add New Item</Link>
//       <ul>
//         {items.map(item => (
//           <li key={item._id}>
//             {item.name}
//             <button onClick={() => deleteMutation.mutate(item._id)}>Delete</button>
//             <Link to={`/dashboard/items/${item._id}/edit`}>Edit</Link>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default ItemList;





// import React, { useState } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import { getItems, deleteItem } from '../../../api/item';
// import { Link } from 'react-router-dom';
// import { Box, Button, VStack, HStack, Text, Spinner, Alert, AlertIcon, AlertTitle, AlertDescription, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useToast } from '@chakra-ui/react';

// const ItemList = () => {
//   const queryClient = useQueryClient();
//   const { data: items, error, isLoading } = useQuery('items', getItems);
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const toast = useToast();
//   const [selectedItemId, setSelectedItemId] = useState(null);

//   const deleteMutation = useMutation(deleteItem, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('items');
//       toast({
//         title: 'Item deleted.',
//         description: 'The item has been deleted successfully.',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       onClose();
//     },
//     onError: () => {
//       toast({
//         title: 'Error deleting item.',
//         description: 'There was an error deleting the item.',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//   });

//   const handleDelete = (id) => {
//     setSelectedItemId(id);
//     onOpen();
//   };

//   const confirmDelete = () => {
//     deleteMutation.mutate(selectedItemId);
//   };

//   if (isLoading) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Spinner size="xl" />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Alert status="error">
//           <AlertIcon />
//           <AlertTitle>Error:</AlertTitle>
//           <AlertDescription>{error.message}</AlertDescription>
//         </Alert>
//       </Box>
//     );
//   }

//   return (
//     <Box maxW="3xl" mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
//       <HStack justify="space-between" mb={4}>
//         <Text fontSize="2xl" fontWeight="bold">Items</Text>
//         <Button colorScheme="blue" as={Link} to="/dashboard/admin/items/new">
//           Add New Item
//         </Button>
//       </HStack>
//       <VStack spacing={4} align="stretch">
//         {items?.data?.data.map((item) => (
//           <Box
//             key={item._id}
//             p={4}
//             borderWidth={1}
//             borderRadius="md"
//             boxShadow="md"
//             _hover={{ boxShadow: 'lg' }}
//           >
//             <HStack justify="space-between">
//               <Text fontSize="lg">{item.name}</Text>
//               <HStack spacing={2}>
//                 <Button colorScheme="teal" as={Link} to={`/dashboard/items/${item._id}`}>
//                   Details
//                 </Button>
//                 <Button colorScheme="teal" as={Link} to={`/dashboard/items/${item._id}/edit`}>
//                   Edit
//                 </Button>
//                 <Button colorScheme="red" onClick={() => handleDelete(item._id)}>
//                   Delete
//                 </Button>
//               </HStack>
//             </HStack>
//             <Text>{item.description}</Text>
//             <Text>Start Price: ${item.startPrice}</Text>
//             <Text>Minimum Bid Increment: ${item.minBidIncrement}</Text>
//             <Text>Deposit: ${item.deposit}</Text>
//             <Text>Number of Items: {item.numberofitem}</Text>
//             <Text>Start Date: {new Date(item.startDate).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}</Text>
//             <Text>End Date: {new Date(item.endDate).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}</Text>
//           </Box>
//         ))}
//       </VStack>

//       <Modal isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Confirm Delete</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Text>Are you sure you want to delete this item?</Text>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme="red" onClick={confirmDelete} mr={3}>
//               Delete
//             </Button>
//             <Button variant="ghost" onClick={onClose}>Cancel</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default ItemList;



// import React, { useState } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import { getItems, deleteItem } from '../../../api/item';
// import { Link } from 'react-router-dom';
// import {
//   Box,
//   Button,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Spinner,
//   Alert,
//   AlertIcon,
//   AlertTitle,
//   AlertDescription,
//   useDisclosure,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalFooter,
//   ModalBody,
//   ModalCloseButton,
//   useToast,
//   Text,
//   HStack,
// } from '@chakra-ui/react';

// const ItemList = () => {
//   const queryClient = useQueryClient();
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const toast = useToast();
//   const [selectedItemId, setSelectedItemId] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 2;

//   const { data: items, error, isLoading } = useQuery(['items', currentPage], () => getItems(currentPage, itemsPerPage));
// console.log(items)
//   const deleteMutation = useMutation(deleteItem, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('items');
//       toast({
//         title: 'Item deleted.',
//         description: 'The item has been deleted successfully.',
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//       onClose();
//     },
//     onError: () => {
//       toast({
//         title: 'Error deleting item.',
//         description: 'There was an error deleting the item.',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//   });

//   const handleDelete = (id) => {
//     setSelectedItemId(id);
//     onOpen();
//   };

//   const confirmDelete = () => {
//     deleteMutation.mutate(selectedItemId);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   if (isLoading) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Spinner size="xl" />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Alert status="error">
//           <AlertIcon />
//           <AlertTitle>Error:</AlertTitle>
//           <AlertDescription>{error.message}</AlertDescription>
//         </Alert>
//       </Box>
//     );
//   }

//   return (
//     <Box  mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
//       <HStack justify="space-between" mb={4}>
//         <Text fontSize="2xl" fontWeight="bold">Items</Text>
//         <Button colorScheme="blue" as={Link} to="/dashboard/admin/items/new">
//           Add New Item
//         </Button>
//       </HStack>
//       <Table  variant="striped" colorScheme="teal">
//         <Thead>
//           <Tr>
//             <Th>Name</Th>
//             <Th>Description</Th>
//             <Th>Start Price</Th>
//             <Th>Min Bid Increment</Th>
//             <Th>Deposit</Th>
//             <Th>Number of Items</Th>
//             <Th>Start Date</Th>
//             <Th>End Date</Th>
//             <Th>Thumbnail</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {items?.data?.data.map((item) => (
//             <Tr key={item._id}>
//               <Td>{item.name}</Td>
//               <Td>{item.description}</Td>
//               <Td>${item.startPrice}</Td>
//               <Td>${item.minBidIncrement}</Td>
//               <Td>${item.deposit}</Td>
//               <Td>{item.numberofitem}</Td>
//               <Td>{new Date(item.startDate).toLocaleString()}</Td>
//               <Td>{new Date(item.endDate).toLocaleString()}</Td>
//               <Td>
//                 <img src={`http://localhost:9000/${item.thubnailphoto.path}`} alt="Thumbnail" width="50" />
//               </Td>
//               <Td>
//                 <HStack spacing={2}>
//                   <Button colorScheme="teal" as={Link} to={`/dashboard/items/${item._id}`}>
//                     Details
//                   </Button>
//                   <Button colorScheme="teal" as={Link} to={`/dashboard/items/${item._id}/edit`}>
//                     Edit
//                   </Button>
//                   <Button colorScheme="red" onClick={() => handleDelete(item._id)}>
//                     Delete
//                   </Button>
//                 </HStack>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <HStack justify="center" mt={4}>
//         {[...Array(Math.ceil(items?.results / itemsPerPage)).keys()].map((page) => (
//           <Button key={page + 1} onClick={() => handlePageChange(page + 1)} isActive={currentPage === page + 1}>
//             {page + 1}
//           </Button>
//         ))}
//       </HStack>

//       <Modal isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Confirm Delete</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Text>Are you sure you want to delete this item?</Text>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme="red" onClick={confirmDelete} mr={3}>
//               Delete
//             </Button>
//             <Button variant="ghost" onClick={onClose}>Cancel</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default ItemList;


import React, { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getItems, deleteItem } from '../../../api/item';
import { Link, useLocation, useNavigate  } from 'react-router-dom';
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useToast,
  Text,
  HStack,
} from '@chakra-ui/react';
import Api from '../../../api/ApiUrl'

const ItemList = () => {
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const [selectedItemId, setSelectedItemId] = useState(null);
  const itemsPerPage = 3;
  
  const location = useLocation();
  const history = useNavigate ();
  
  const queryParams = new URLSearchParams(location.search);
  const page = parseInt(queryParams.get('page') || '1', 10);
  const [currentPage, setCurrentPage] = useState(page);

  const { data: items, error, isLoading } = useQuery(['items', currentPage], () => getItems(currentPage, itemsPerPage), {
    keepPreviousData: true,
  });

  const deleteMutation = useMutation(deleteItem, {
    onSuccess: () => {
      queryClient.invalidateQueries('items');
      toast({
        title: 'Item deleted.',
        description: 'The item has been deleted successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    },
    onError: () => {
      toast({
        title: 'Error deleting item.',
        description: 'There was an error deleting the item.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleDelete = (id) => {
    setSelectedItemId(id);
    onOpen();
  };

  const confirmDelete = () => {
    deleteMutation.mutate(selectedItemId);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    history(`?page=${page}`);
  };

  useEffect(() => {
    setCurrentPage(page);
  }, [page]);

  if (isLoading) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>Error:</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Alert>
      </Box>
    );
  }

  return (
    <Box mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
      <HStack justify="space-between" mb={4}>
        <Text fontSize="2xl" fontWeight="bold">Items</Text>
        <Button colorScheme="blue" as={Link} to="/dashboard/admin/items/new">
          Add New Item
        </Button>
      </HStack>
      <Table variant="striped" colorScheme="teal">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Description</Th>
            <Th>Start Price</Th>
            <Th>Min Bid Increment</Th>
            <Th>Deposit</Th>
            <Th>Number of Items</Th>
            <Th>Start Date</Th>
            <Th>End Date</Th>
            <Th>Thumbnail</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items?.data?.data.map((item) => (
            <Tr key={item._id}>
              <Td>{item.name}</Td>
              <Td>{item.description}</Td>
              <Td>${item.startPrice}</Td>
              <Td>${item.minBidIncrement}</Td>
              <Td>${item.deposit}</Td>
              <Td>{item.numberofitem}</Td>
              <Td>{new Date(item.startDate).toLocaleString()}</Td>
              <Td>{new Date(item.endDate).toLocaleString()}</Td>
              <Td>
                <img src={`${Api}/${item?.coverphoto?.path}`} alt="Thumbnail" width="50" />
              </Td>
              <Td>
                <HStack spacing={2}>
                  <Button colorScheme="teal" as={Link} to={`/dashboard/items/${item._id}`}>
                    Details
                  </Button>
                  <Button colorScheme="teal" as={Link} to={`/dashboard/admin/items/${item._id}/edit`}> 
                    Edit
                  </Button>
                  <Button colorScheme="red" onClick={() => handleDelete(item._id)}>
                    Delete
                  </Button>
                </HStack>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      <HStack justify="center" mt={4}>
        {[...Array(Math.ceil(items?.counts / itemsPerPage)).keys()].map((page) => (
          <Button key={page + 1} onClick={() => handlePageChange(page + 1)} isActive={currentPage === page + 1}>
            {page + 1}
          </Button>
        ))}
      </HStack>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Delete</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this item?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" onClick={confirmDelete} mr={3}>
              Delete
            </Button>
            <Button variant="ghost" onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ItemList;
